// 解除内存地址
let createNewVariable = (variable) => {
  return JSON.parse(JSON.stringify(variable));
}

// 对象转数组
let objToArray = target => Array.isArray(target) ? target : [target];

// 深度优先搜索
let depthSearchTree = (
  func = () => { },
  node = [],
  childrenKey = 'children',
  parentKey,
  parent = {}
) => {
  let newNode = objToArray(node);
  newNode.forEach(value => {
    if (parentKey) {
      value[parentKey] = parent;
    }
    func(value);
    let children = value[childrenKey];
    if (children) {
      depthSearchTree(func, children, childrenKey, parentKey, value);
    }
  });
}

// 广度优先搜索
let breadthSearchTree = (
  func = () => { },
  node = [],
  childrenKey = 'children'
) => {
  let newNode = objToArray(node);
  while (newNode.length > 0) {
    let n = objToArray(newNode.shift());
    n.forEach(value => {
      func(value);
      let children = value[childrenKey];
      if (children) {
        newNode.push(children);
      }
    });
  }
}

// 防抖
let debounce = (fn = () => {}, delay = 300) => {
  let timer;
  return (...args) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn(...args);
      timer = null;
    }, delay);
  };
}

// 节流
let throttle = (fn = () => {}, delay = 300) => {
  let timer;
  return (...args) => {
    if (timer) {
      return;
    }
    timer = setTimeout(() => {
      fn(...args);
      timer = null;
    }, delay);
  };
}

// 倒计时
let initInterval = (time, callback = () => { }, endCallback = () => { }) => {
  callback(time);
  let interval = setInterval(() => {
    if (time) {
      time--;
      callback(time);
    } else {
      clearInterval(interval);
      interval = null;
      endCallback();
    }
  }, 1000);
}

// 生成树节点路径
let createTreeNodePath = (
  node,
  key = 'id',
  parentKey = 'parent'
) => {
  let path = [];
  depthSearchTree(
    val => {
      if (val[parentKey]) {
        path.push(createValue(val, key));
      }
    },
    node,
    parentKey
  );
  return path.reverse();
}

// 字符串转对象 获取值
let createValue = (
  data,
  key
) => {
  let value = data;
  key.split('.').forEach(val => {
    value = value[val];
  });
  return value;
}

// 搜索项展开关闭
let switchSearchRegion = (
  doms,
  status,
  count = 4
) => {
  doms.forEach((value, index) => {
    if (index >= count) {
      value.style.display = status ? 'block' : 'none';
    }
  });
}

let setWatermark = (str1, str2) => {
  let id = '1.23452384164.123412415'

  if (document.getElementById(id) !== null) {
    document.body.removeChild(document.getElementById(id))
  }

  let can = document.createElement('canvas')
  // 设置canvas画布大小
  can.width = 200
  can.height = 200

  let cans = can.getContext('2d')
  cans.rotate(-20 * Math.PI / 180) // 水印旋转角度
  cans.font = '16px Vedana'
  cans.fillStyle = '#000000'
  cans.textAlign = 'center'
  cans.textBaseline = 'Middle'
  cans.fillText(str1, can.width / 4, can.height / 2) // 水印在画布的位置x，y轴
  cans.fillText(str2, can.width / 4, can.height / 1.2)

  let div = document.createElement('div')
  div.id = id
  div.style.pointerEvents = 'none'
  div.style.top = '40px'
  div.style.left = '0px'
  div.style.opacity = '.4'
  div.style.position = 'fixed'
  div.style.zIndex = '100000'
  div.style.width = document.documentElement.clientWidth + 'px'
  div.style.height = document.documentElement.clientHeight + 'px'
  div.style.background = 'url(' + can.toDataURL('image/png') + ') left top repeat'
  document.body.appendChild(div)
  return id
}

// 添加水印方法
let setWaterMark = (str1, str2) => {
  let id = setWatermark(str1, str2)
  if (document.getElementById(id) === null) {
    id = setWatermark(str1, str2)
  }
}

// 移除水印方法
let removeWatermark = () => {
  let id = '1.23452384164.123412415'
  if (document.getElementById(id) !== null) {
    document.body.removeChild(document.getElementById(id))
  }
}

let install = (Vue, options = {}) => {
  Vue.prototype.setWaterMark = setWaterMark;
  Vue.prototype.removeWatermark = removeWatermark;
  Vue.prototype.createNewVariable = createNewVariable;
  Vue.prototype.objToArray = objToArray;
  Vue.prototype.depthSearchTree = depthSearchTree;
  Vue.prototype.breadthSearchTree = breadthSearchTree;
  Vue.prototype.initInterval = initInterval;
  Vue.prototype.debounce = debounce;
  Vue.prototype.throttle = throttle;
  Vue.prototype.createTreeNodePath = createTreeNodePath;
  Vue.prototype.switchSearchRegion = switchSearchRegion;
  Vue.prototype.defaultAvatar = 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png';
  Vue.prototype.dialogWidth = '40%';
  Vue.prototype.labelWidth = '96px';
};

export default {
  install
};